import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-27781f62"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "analysis-wrap"
};
const _hoisted_2 = {
  class: "content title"
};
const _hoisted_3 = {
  class: "match-meta"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = {
  key: 0,
  class: "update-bar"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "update-label"
}, "🕐 最近更新", -1));
const _hoisted_9 = {
  class: "update-time"
};
const _hoisted_10 = {
  key: 1,
  class: "update-bar pending"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "update-label"
}, "分析将在节点时间自动生成，也可点下方节点手动查看", -1));
const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = {
  key: 2,
  class: "timeline"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "node-dot"
};
const _hoisted_16 = {
  class: "node-info"
};
const _hoisted_17 = {
  class: "node-label"
};
const _hoisted_18 = {
  class: "node-time"
};
const _hoisted_19 = {
  key: 3,
  class: "no-data"
};
const _hoisted_20 = {
  key: 4,
  class: "no-data"
};
const _hoisted_21 = {
  key: 0
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  class: "rec-card highlight"
};
const _hoisted_24 = {
  class: "rec-head"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "综合推荐", -1));
const _hoisted_26 = {
  key: 0,
  class: "rec-time"
};
const _hoisted_27 = {
  class: "dual"
};
const _hoisted_28 = {
  class: "dual-item"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dual-label"
}, "胜平负", -1));
const _hoisted_30 = {
  key: 0,
  class: "dual-reason"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dual-divider"
}, null, -1));
const _hoisted_32 = {
  class: "dual-item"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dual-label"
}, "让球胜平负", -1));
const _hoisted_34 = {
  key: 0,
  class: "dual-reason"
};
const _hoisted_35 = {
  class: "total-conf"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "total-label"
}, "总置信度", -1));
const _hoisted_37 = {
  key: 0,
  class: "summary"
};
const _hoisted_38 = {
  key: 1,
  class: "change-bar"
};
const _hoisted_39 = {
  class: "metric-card"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-title"
}, "💪 实力差", -1));
const _hoisted_41 = {
  class: "metric-row"
};
const _hoisted_42 = {
  class: "home-color"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "vs"
}, "vs", -1));
const _hoisted_44 = {
  class: "away-color"
};
const _hoisted_45 = {
  class: "metric-sub"
};
const _hoisted_46 = {
  key: 0,
  class: "ai-text"
};
const _hoisted_47 = {
  class: "metric-card"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-title"
}, "🔥 热度值", -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "heat-group-label"
}, "胜平负热度", -1));
const _hoisted_50 = {
  class: "heat-row"
};
const _hoisted_51 = {
  class: "heat-item"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "heat-label home-color"
}, "胜", -1));
const _hoisted_53 = {
  class: "heat-num"
};
const _hoisted_54 = {
  class: "heat-item"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "heat-label"
}, "平", -1));
const _hoisted_56 = {
  class: "heat-num"
};
const _hoisted_57 = {
  class: "heat-item"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "heat-label away-color"
}, "负", -1));
const _hoisted_59 = {
  class: "heat-num"
};
const _hoisted_60 = {
  class: "metric-sub"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "heat-group-label"
}, "让球胜平负热度", -1));
const _hoisted_62 = {
  class: "heat-row"
};
const _hoisted_63 = {
  class: "heat-item"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "heat-label home-color"
}, "让胜", -1));
const _hoisted_65 = {
  class: "heat-num"
};
const _hoisted_66 = {
  class: "heat-item"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "heat-label"
}, "让平", -1));
const _hoisted_68 = {
  class: "heat-num"
};
const _hoisted_69 = {
  class: "heat-item"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "heat-label away-color"
}, "让负", -1));
const _hoisted_71 = {
  class: "heat-num"
};
const _hoisted_72 = {
  class: "metric-sub"
};
const _hoisted_73 = {
  key: 0,
  class: "ai-text"
};
const _hoisted_74 = {
  class: "metric-card"
};
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-title"
}, "🧲 拉力值", -1));
const _hoisted_76 = {
  class: "metric-row"
};
const _hoisted_77 = {
  class: "home-color"
};
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "vs"
}, "vs", -1));
const _hoisted_79 = {
  class: "away-color"
};
const _hoisted_80 = {
  key: 0,
  class: "ai-text"
};
const _hoisted_81 = {
  key: 1,
  class: "no-data"
};
const _hoisted_82 = {
  key: 2,
  class: "rec-card"
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-title"
}, "🧠 关键推理", -1));
const _hoisted_84 = {
  key: 3,
  class: "rec-card risk-card"
};
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-title"
}, "⚠️ 风险提示", -1));
const _hoisted_86 = {
  class: "risk-text"
};
const _hoisted_87 = {
  key: 6,
  class: "no-data"
};
const _hoisted_88 = {
  key: 0,
  class: "rec-card pricing-card"
};
const _hoisted_89 = {
  class: "pricing-head"
};
const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "metric-title"
}, "📊 量化定价", -1));
const _hoisted_91 = {
  class: "rec-time"
};
const _hoisted_92 = {
  class: "pricing-top"
};
const _hoisted_93 = {
  class: "conv-num"
};
const _hoisted_94 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "conv-label"
}, "收敛分", -1));
const _hoisted_95 = {
  key: 0,
  class: "pick-box"
};
const _hoisted_96 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pick-label"
}, "单挑", -1));
const _hoisted_97 = {
  class: "pick-meta"
};
const _hoisted_98 = {
  key: 1,
  class: "pick-box pass-box"
};
const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pick-label"
}, "单挑", -1));
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pick-main pass"
}, "PASS", -1));
const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pick-meta"
}, "信号未收敛，不出手", -1));
const _hoisted_102 = [_hoisted_99, _hoisted_100, _hoisted_101];
const _hoisted_103 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pricing-group-label"
}, "净胜球概率分布", -1));
const _hoisted_104 = {
  class: "goaldiff-bars"
};
const _hoisted_105 = {
  class: "gd-bar-wrap"
};
const _hoisted_106 = {
  class: "gd-net"
};
const _hoisted_107 = {
  class: "gd-prob"
};
const _hoisted_108 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pricing-group-label"
}, [/*#__PURE__*/_createTextVNode("三市场 EV "), /*#__PURE__*/_createElementVNode("span", {
  class: "rec-time"
}, "EV+ 有价值")], -1));
const _hoisted_109 = {
  class: "ev-table"
};
const _hoisted_110 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", null, "市场"), /*#__PURE__*/_createElementVNode("th", null, "选项"), /*#__PURE__*/_createElementVNode("th", null, "概率"), /*#__PURE__*/_createElementVNode("th", null, "赔率"), /*#__PURE__*/_createElementVNode("th", null, "EV")])], -1));
const _hoisted_111 = {
  key: 0,
  class: "pricing-group-label"
};
const _hoisted_112 = {
  key: 1,
  class: "prob-compare"
};
const _hoisted_113 = {
  class: "pc-col"
};
const _hoisted_114 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pc-label"
}, "M1泊松", -1));
const _hoisted_115 = {
  class: "pc-val"
};
const _hoisted_116 = {
  key: 0,
  class: "pc-col"
};
const _hoisted_117 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pc-label"
}, "M2机器学习", -1));
const _hoisted_118 = {
  class: "pc-val"
};
const _hoisted_119 = {
  class: "pc-col"
};
const _hoisted_120 = {
  class: "pc-label"
};
const _hoisted_121 = {
  class: "pc-val"
};
const _hoisted_122 = {
  key: 2,
  class: "pricing-meta"
};
const _hoisted_123 = {
  key: 3,
  class: "pricing-reason"
};
const _hoisted_124 = {
  key: 1,
  class: "no-data"
};
const _hoisted_125 = {
  key: 0,
  class: "member-mask"
};
const _hoisted_126 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "member-mask-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "member-icon"
}, "🔒"), /*#__PURE__*/_createElementVNode("div", {
  class: "member-title"
}, "会员专属"), /*#__PURE__*/_createElementVNode("div", {
  class: "member-desc"
}, "AI 分析为会员专享功能"), /*#__PURE__*/_createElementVNode("div", {
  class: "member-contact"
}, "联系客服开通会员后解锁查看")], -1));
const _hoisted_127 = [_hoisted_126];
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import apiFoot from '@/utils/apiFoot';
import { showNotify } from '@nutui/nutui';
const PRICING_ENABLED = false;
export default {
  __name: 'MatchAnalysisView',
  setup(__props, {
    expose: __expose
  }) {
    const store = useStore();
    const isVisible = ref(false);
    const loading = ref(false);
    const matchId = ref('');
    const homeTeam = ref('');
    const awayTeam = ref('');
    const league = ref('');
    const matchNumStr = ref('');
    const matchTime = ref('');
    const deadline = ref('');
    const latestUpdateTime = ref('');
    const nodes = ref([]);
    const currentIdx = ref(-1);
    const pricing = ref(null);
    const pricingLoaded = ref(false);
    // 量化定价卡片开关：效果待优化，默认隐藏；true 恢复显示
    const isMember = computed(() => store.state.fullUser);
    const currentNode = computed(() => nodes.value[currentIdx.value] || null);
    const metric = computed(() => currentNode.value?.metric || null);
    const show = id => {
      matchId.value = id;
      isVisible.value = true;
      loading.value = true;
      nodes.value = [];
      currentIdx.value = -1;
      pricing.value = null;
      pricingLoaded.value = false;
      fetchAnalysis();
      if (PRICING_ENABLED) fetchPricing();
    };
    const close = () => {
      isVisible.value = false;
    };
    const fetchAnalysis = async () => {
      try {
        // apiFoot 自动附加签名并解密加密响应，data 即原始 {matchInfo, nodes}
        const data = await apiFoot.get('/matchAnalysisAi/list', {
          params: {
            matchId: matchId.value
          }
        });
        const info = data.matchInfo || {};
        homeTeam.value = info.homeTeam || '';
        awayTeam.value = info.awayTeam || '';
        league.value = info.league || '';
        matchNumStr.value = info.matchNumStr || '';
        matchTime.value = info.matchTime || '';
        deadline.value = info.deadline || '';
        latestUpdateTime.value = data.latestUpdateTime || '';
        nodes.value = (data.nodes || []).map(n => ({
          ...n,
          reasoningPoints: n.reasoningPoints || [],
          interpretations: n.interpretations || {}
        }));
        // 默认选中最新已成功节点
        for (let i = nodes.value.length - 1; i >= 0; i--) {
          if (nodes.value[i].status === 1) {
            currentIdx.value = i;
            break;
          }
        }
      } catch (e) {
        console.error('获取AI四指标分析失败', e);
        showNotify.warn('AI四指标分析加载失败，请稍后重试');
      } finally {
        loading.value = false;
      }
    };
    const selectNode = i => {
      currentIdx.value = i;
    };

    // ==================== 量化定价 ====================
    const fetchPricing = async () => {
      try {
        const data = await apiFoot.get('/pricing/card', {
          params: {
            matchId: matchId.value
          }
        });
        pricing.value = data && !data.error ? data : null;
      } catch (e) {
        console.error('获取量化定价失败', e);
        pricing.value = null;
      } finally {
        pricingLoaded.value = true;
      }
    };
    const bestOption = computed(() => {
      const opts = pricing.value?.options;
      if (!opts || !opts.length) return null;
      return opts.reduce((b, o) => o.ev > b.ev ? o : b);
    });
    const goalDiffArr = computed(() => {
      const d = pricing.value?.goalDiffDist || {};
      const arr = Object.entries(d).map(([k, v]) => ({
        net: parseInt(k, 10),
        prob: v
      }));
      const maxP = arr.length ? Math.max(...arr.map(x => x.prob)) : 0;
      return arr.map(x => ({
        ...x,
        isPeak: x.prob === maxP
      }));
    });
    const fmtEv = v => v === null || v === undefined || isNaN(v) ? '-' : (v >= 0 ? '+' : '') + (v * 100).toFixed(1) + '%';
    const fmtProbArr = arr => arr && arr.length ? arr.map(x => Math.round(x * 100) + '%').join('/') : '-';
    const pct = v => v === null || v === undefined ? '-' : Math.round(v * 100) + '%';
    const evClass = v => v >= 0.03 ? 'ev-pos' : v < 0 ? 'ev-neg' : 'ev-mid';
    const scoreClass = s => s >= 60 ? 'score-high' : s >= 40 ? 'score-mid' : 'score-low';
    const dirClass = d => {
      if (d === '主胜' || d === '让胜') return 'home-color';
      if (d === '客胜' || d === '让负') return 'away-color';
      return 'draw-color';
    };

    // ==================== 工具 ====================
    const fmt = v => v === null || v === undefined ? '-' : v;
    const formatTime = t => t ? t.replace(/^\d{4}-/, '') : '';
    const showChange = computed(() => {
      const c = currentNode.value?.changeExplanation;
      return c && !/首个|无显著变化/.test(c);
    });
    const hadClass = computed(() => {
      const r = currentNode.value?.had?.recommendation || '';
      if (r.includes('主胜')) return 'home-color';
      if (r.includes('客胜')) return 'away-color';
      return 'draw-color';
    });
    const hhadClass = computed(() => {
      const r = currentNode.value?.hhad?.recommendation || '';
      if (r.includes('让胜')) return 'home-color';
      if (r.includes('让负')) return 'away-color';
      return 'draw-color';
    });
    const confClass = c => {
      if (c >= 70) return 'high-confidence';
      if (c >= 40) return 'mid-confidence';
      return 'low-confidence';
    };
    const confColor = c => {
      if (c >= 70) return '#27ae60';
      if (c >= 40) return '#f39c12';
      return '#e74c3c';
    };
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_var_progress = _resolveComponent("var-progress");
      const _component_var_chip = _resolveComponent("var-chip");
      const _component_var_loading = _resolveComponent("var-loading");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => isVisible.value = $event),
        closeable: "",
        style: {
          padding: '50px 12px 20px',
          height: '88%',
          width: '92%',
          overflowY: 'auto',
          overflowX: 'hidden'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: _normalizeClass(['analysis-content', {
            'is-blurred': !isMember.value
          }])
        }, [_createVNode(_component_var_loading, {
          description: "加载中",
          loading: loading.value
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(homeTeam.value) + " vs " + _toDisplayString(awayTeam.value), 1), _createElementVNode("div", _hoisted_3, [matchNumStr.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(matchNumStr.value) + " · ", 1)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(league.value) + " ", 1), matchTime.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · 开赛 " + _toDisplayString(matchTime.value), 1)) : _createCommentVNode("", true), deadline.value ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · 截单 " + _toDisplayString(deadline.value), 1)) : _createCommentVNode("", true)]), latestUpdateTime.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(formatTime(latestUpdateTime.value)), 1)])) : nodes.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)) : _createCommentVNode("", true), nodes.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nodes.value, (n, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: n.slot,
              class: _normalizeClass(["node", {
                active: currentIdx.value === i,
                done: n.status === 1,
                failed: n.status === 2
              }]),
              onClick: $event => selectNode(i)
            }, [_createElementVNode("div", _hoisted_15, [n.status === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode("✓")], 64)) : n.status === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_createTextVNode("!")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [_createTextVNode("·")], 64))]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(n.label), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(n.scheduledTime), 1)]), _createElementVNode("div", {
              class: _normalizeClass(["node-status", {
                done: n.status === 1
              }])
            }, _toDisplayString(n.status === 1 ? '已生成' : n.status === 2 ? '失败' : '待生成'), 3)], 10, _hoisted_14);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_19, "暂无分析结果，将在 12:00 / 赛前 8h / 5h / 3h / 1h / 30分钟 自动生成")), currentNode.value && currentNode.value.status !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createTextVNode(_toDisplayString(currentNode.value.label) + " 尚未生成", 1), currentNode.value.scheduledTime ? (_openBlock(), _createElementBlock("span", _hoisted_21, "，计划 " + _toDisplayString(currentNode.value.scheduledTime), 1)) : _createCommentVNode("", true), _createTextVNode("，将自动分析"), currentNode.value.lastError ? (_openBlock(), _createElementBlock("span", _hoisted_22, "；最近失败：" + _toDisplayString(currentNode.value.lastError), 1)) : _createCommentVNode("", true)])) : currentNode.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 5
          }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, currentNode.value.updateTime ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(formatTime(currentNode.value.updateTime)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", {
            class: _normalizeClass(["dual-main", hadClass.value])
          }, _toDisplayString(currentNode.value.had.recommendation), 3), _createElementVNode("div", {
            class: _normalizeClass(["dual-conf", confClass(currentNode.value.had.confidence)])
          }, _toDisplayString(currentNode.value.had.confidence || '-') + "%", 3), currentNode.value.had.reason ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(currentNode.value.had.reason), 1)) : _createCommentVNode("", true)]), _hoisted_31, _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", {
            class: _normalizeClass(["dual-main", hhadClass.value])
          }, _toDisplayString(currentNode.value.hhad.recommendation), 3), _createElementVNode("div", {
            class: _normalizeClass(["dual-conf", confClass(currentNode.value.hhad.confidence)])
          }, _toDisplayString(currentNode.value.hhad.confidence || '-') + "%", 3), currentNode.value.hhad.reason ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(currentNode.value.hhad.reason), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("span", {
            class: _normalizeClass(["total-num", confClass(currentNode.value.totalConfidence)])
          }, _toDisplayString(currentNode.value.totalConfidence || '-') + "%", 3), _createVNode(_component_var_progress, {
            value: currentNode.value.totalConfidence,
            max: 100,
            color: confColor(currentNode.value.totalConfidence),
            style: {
              "margin-top": "4px"
            }
          }, null, 8, ["value", "color"])]), currentNode.value.summary ? (_openBlock(), _createElementBlock("div", _hoisted_37, "📝 " + _toDisplayString(currentNode.value.summary), 1)) : _createCommentVNode("", true), showChange.value ? (_openBlock(), _createElementBlock("div", _hoisted_38, "🔔 " + _toDisplayString(currentNode.value.changeExplanation), 1)) : _createCommentVNode("", true)]), metric.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, "主 " + _toDisplayString(fmt(metric.value.strengthDiff?.homeStrength)), 1), _hoisted_43, _createElementVNode("span", _hoisted_44, "客 " + _toDisplayString(fmt(metric.value.strengthDiff?.awayStrength)), 1), _createElementVNode("span", {
            class: _normalizeClass(["metric-diff", metric.value.strengthDiff?.strengthDiff > 0 ? 'home-color' : 'away-color'])
          }, _toDisplayString(metric.value.strengthDiff?.strengthDiff > 0 ? '+' : '') + _toDisplayString(fmt(metric.value.strengthDiff?.strengthDiff)), 3)]), _createVNode(_component_var_progress, {
            value: metric.value.strengthDiff?.homeStrength,
            max: 100,
            color: "#e74c3c"
          }, null, 8, ["value"]), _createElementVNode("div", _hoisted_45, [_createElementVNode("span", null, "盘口 " + _toDisplayString(fmt(metric.value.strengthDiff?.calculatedHandicap)) + " / 机构 " + _toDisplayString(fmt(metric.value.strengthDiff?.actualHandicap)), 1), _createVNode(_component_var_chip, {
            size: "small",
            type: metric.value.strengthDiff?.handicapDiffLabel === '盘口合理' ? 'default' : 'primary'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(metric.value.strengthDiff?.handicapDiffLabel), 1)]),
            _: 1
          }, 8, ["type"])]), currentNode.value.interpretations?.strength ? (_openBlock(), _createElementBlock("div", _hoisted_46, "🤖 " + _toDisplayString(currentNode.value.interpretations.strength), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_47, [_hoisted_48, _hoisted_49, _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_hoisted_52, _createElementVNode("div", _hoisted_53, _toDisplayString(fmt(metric.value.heatAnalysis?.hadHomeHeat)), 1), _createVNode(_component_var_progress, {
            value: metric.value.heatAnalysis?.hadHomeHeat,
            max: 100,
            color: "#e74c3c"
          }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, _toDisplayString(fmt(metric.value.heatAnalysis?.hadDrawHeat)), 1), _createVNode(_component_var_progress, {
            value: metric.value.heatAnalysis?.hadDrawHeat,
            max: 100,
            color: "#f39c12"
          }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_57, [_hoisted_58, _createElementVNode("div", _hoisted_59, _toDisplayString(fmt(metric.value.heatAnalysis?.hadAwayHeat)), 1), _createVNode(_component_var_progress, {
            value: metric.value.heatAnalysis?.hadAwayHeat,
            max: 100,
            color: "#3498db"
          }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_60, [_createVNode(_component_var_chip, {
            size: "small",
            type: metric.value.heatAnalysis?.hadHeatDirection === '主热' ? 'danger' : metric.value.heatAnalysis?.hadHeatDirection === '客热' ? 'primary' : 'default'
          }, {
            default: _withCtx(() => [_createTextVNode(" 方向 " + _toDisplayString(metric.value.heatAnalysis?.hadHeatDirection), 1)]),
            _: 1
          }, 8, ["type"])]), _hoisted_61, _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_hoisted_64, _createElementVNode("div", _hoisted_65, _toDisplayString(fmt(metric.value.heatAnalysis?.hhadHomeHeat)), 1), _createVNode(_component_var_progress, {
            value: metric.value.heatAnalysis?.hhadHomeHeat,
            max: 100,
            color: "#e74c3c"
          }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_66, [_hoisted_67, _createElementVNode("div", _hoisted_68, _toDisplayString(fmt(metric.value.heatAnalysis?.hhadDrawHeat)), 1), _createVNode(_component_var_progress, {
            value: metric.value.heatAnalysis?.hhadDrawHeat,
            max: 100,
            color: "#f39c12"
          }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_69, [_hoisted_70, _createElementVNode("div", _hoisted_71, _toDisplayString(fmt(metric.value.heatAnalysis?.hhadAwayHeat)), 1), _createVNode(_component_var_progress, {
            value: metric.value.heatAnalysis?.hhadAwayHeat,
            max: 100,
            color: "#3498db"
          }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_72, [_createVNode(_component_var_chip, {
            size: "small",
            type: metric.value.heatAnalysis?.hhadHeatDirection === '主热' ? 'danger' : metric.value.heatAnalysis?.hhadHeatDirection === '客热' ? 'primary' : 'default'
          }, {
            default: _withCtx(() => [_createTextVNode(" 方向 " + _toDisplayString(metric.value.heatAnalysis?.hhadHeatDirection), 1)]),
            _: 1
          }, 8, ["type"])]), currentNode.value.interpretations?.heat ? (_openBlock(), _createElementBlock("div", _hoisted_73, "🤖 " + _toDisplayString(currentNode.value.interpretations.heat), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_74, [_hoisted_75, _createElementVNode("div", _hoisted_76, [_createElementVNode("span", _hoisted_77, "主 " + _toDisplayString(fmt(metric.value.pullAnalysis?.homePull)), 1), _hoisted_78, _createElementVNode("span", _hoisted_79, "客 " + _toDisplayString(fmt(metric.value.pullAnalysis?.awayPull)), 1), _createElementVNode("span", {
            class: _normalizeClass(["metric-diff", metric.value.pullAnalysis?.pullDiff > 0 ? 'home-color' : 'away-color'])
          }, _toDisplayString(metric.value.pullAnalysis?.pullDiff > 0 ? '+' : '') + _toDisplayString(fmt(metric.value.pullAnalysis?.pullDiff)) + " " + _toDisplayString(metric.value.pullAnalysis?.pullDirection), 3)]), _createVNode(_component_var_progress, {
            value: metric.value.pullAnalysis?.homePull,
            max: 100,
            color: "#e74c3c"
          }, null, 8, ["value"]), currentNode.value.interpretations?.pull ? (_openBlock(), _createElementBlock("div", _hoisted_80, "🤖 " + _toDisplayString(currentNode.value.interpretations.pull), 1)) : _createCommentVNode("", true)])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_81, "该节点无量化指标数据")), currentNode.value.reasoningPoints && currentNode.value.reasoningPoints.length ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_hoisted_83, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentNode.value.reasoningPoints, (p, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              class: "reason-point"
            }, "· " + _toDisplayString(p), 1);
          }), 128))])) : _createCommentVNode("", true), currentNode.value.risk ? (_openBlock(), _createElementBlock("div", _hoisted_84, [_hoisted_85, _createElementVNode("div", _hoisted_86, _toDisplayString(currentNode.value.risk), 1)])) : _createCommentVNode("", true)], 64)) : nodes.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_87, "暂无已生成的分析结果")) : _createCommentVNode("", true), PRICING_ENABLED ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 7
          }, [pricing.value ? (_openBlock(), _createElementBlock("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_hoisted_90, _createElementVNode("span", _hoisted_91, _toDisplayString(pricing.value.snapshotTime), 1)]), _createElementVNode("div", _hoisted_92, [_createElementVNode("div", {
            class: _normalizeClass(["conv-score", scoreClass(pricing.value.convergenceScore)])
          }, [_createElementVNode("div", _hoisted_93, _toDisplayString(pricing.value.convergenceScore), 1), _hoisted_94], 2), pricing.value.singlePick ? (_openBlock(), _createElementBlock("div", _hoisted_95, [_hoisted_96, _createElementVNode("div", {
            class: _normalizeClass(["pick-main", dirClass(pricing.value.singlePick.direction)])
          }, _toDisplayString(pricing.value.singlePick.market) + " " + _toDisplayString(pricing.value.singlePick.direction), 3), _createElementVNode("div", _hoisted_97, "赔率 " + _toDisplayString(pricing.value.singlePick.odds) + " · EV " + _toDisplayString(fmtEv(pricing.value.singlePick.ev)) + " · 概率 " + _toDisplayString(pct(pricing.value.singlePick.prob)), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_98, _hoisted_102))]), _hoisted_103, _createElementVNode("div", _hoisted_104, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goalDiffArr.value, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.net,
              class: _normalizeClass(["gd-col", {
                peak: item.isPeak
              }])
            }, [_createElementVNode("div", _hoisted_105, [_createElementVNode("div", {
              class: _normalizeClass(["gd-bar", item.net > 0 ? 'bar-home' : item.net < 0 ? 'bar-away' : 'bar-draw']),
              style: _normalizeStyle({
                height: item.prob * 90 + 'px'
              })
            }, null, 6)]), _createElementVNode("div", _hoisted_106, _toDisplayString(item.net > 0 ? '+' + item.net : item.net), 1), _createElementVNode("div", _hoisted_107, _toDisplayString(pct(item.prob)), 1)], 2);
          }), 128))]), _hoisted_108, _createElementVNode("table", _hoisted_109, [_hoisted_110, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pricing.value.options, (o, i) => {
            return _openBlock(), _createElementBlock("tr", {
              key: i,
              class: _normalizeClass({
                'best-row': bestOption.value && o.direction === bestOption.value.direction
              })
            }, [_createElementVNode("td", null, _toDisplayString(o.market), 1), _createElementVNode("td", null, _toDisplayString(o.direction), 1), _createElementVNode("td", null, _toDisplayString(pct(o.prob)), 1), _createElementVNode("td", null, _toDisplayString(o.odds), 1), _createElementVNode("td", {
              class: _normalizeClass(evClass(o.ev))
            }, _toDisplayString(fmtEv(o.ev)), 3)], 2);
          }), 128))])]), pricing.value.m2 && pricing.value.fused ? (_openBlock(), _createElementBlock("div", _hoisted_111, "概率对比（主/平/客）")) : _createCommentVNode("", true), pricing.value.m2 && pricing.value.fused ? (_openBlock(), _createElementBlock("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_hoisted_114, _createElementVNode("div", _hoisted_115, _toDisplayString(fmtProbArr(pricing.value.modelProb)), 1)]), pricing.value.m2.hadProb ? (_openBlock(), _createElementBlock("div", _hoisted_116, [_hoisted_117, _createElementVNode("div", _hoisted_118, _toDisplayString(fmtProbArr(pricing.value.m2.hadProb)), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_119, [_createElementVNode("div", _hoisted_120, "融合 w1=" + _toDisplayString(pricing.value.fused.w1), 1), _createElementVNode("div", _hoisted_121, _toDisplayString(fmtProbArr(pricing.value.fused.hadProb)), 1)])])) : _createCommentVNode("", true), pricing.value.model ? (_openBlock(), _createElementBlock("div", _hoisted_122, " λ主 " + _toDisplayString(pricing.value.model.lambdaHome) + " · λ客 " + _toDisplayString(pricing.value.model.lambdaAway) + " · 背离 " + _toDisplayString(pricing.value.model.divergence), 1)) : _createCommentVNode("", true), pricing.value.reason ? (_openBlock(), _createElementBlock("div", _hoisted_123, "💡 " + _toDisplayString(pricing.value.reason), 1)) : _createCommentVNode("", true)])) : pricingLoaded.value && !pricing.value ? (_openBlock(), _createElementBlock("div", _hoisted_124, "量化定价不可用（缺少竞彩赔率数据）")) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["loading"])], 2), !isMember.value ? (_openBlock(), _createElementBlock("div", _hoisted_125, _hoisted_127)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};